import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: 'handleClick'
        }
    }

    init() {
    }

    handleClick() {
        const target = this.el.dataset.target;

        if(target) {
            this.call('scrollTo', { target: target, option: { duration: 900 } }, 'Scroll')
        }
    }
}
